import { getAllCountries } from 'countries-and-timezones';
import { getCountryFlag } from './flag';

export const getCountryOptions = () => {
  return Object.values(getAllCountries())
    .map(({ id, name }) => ({
      value: id,
      label: `${getCountryFlag(id)} ${name}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
